import moneyString from '../moneyString.js'
import extraDays from './extraDays.js'
import travelProtection from './travelProtection.js'
import transfers from './transfers.js'
import prePaidGratuities from './prePaidGratuities.js'
import party from './party.js'
import flights from './flights.js'
import {getConfirmationType} from '../../tripSummaryUtils.js'

function isInitialPageLoad (oldState, newState) {
  return (!oldState || !oldState.tab) && (newState && newState.tab)
}

function isTabChange (oldState, newState) {
  return (oldState && oldState.tab) && oldState.tab != newState.tab
}

function updateCartWithPromotions (cartJson, priceBreakdown) {
  if (priceBreakdown.hasDiscounts) {
    priceBreakdown.discounts.promotions.applied.forEach((promotion) => {
      promotion.products.forEach((product) => {
        cartJson.lines.forEach((line) => {
          if ( (line.product.id === product.productCode) || (line.product.id == 'flights' && promotion.isAirPromotion)) {
            if (!line.discount) {
              line.discount = {}
              line.discount.lines = []
            }
            line.discount.lines.push({id: promotion.code, value: moneyString(promotion.amount)})
            line.discount.value = moneyString(priceBreakdown.discounts.promotions.amount)
          }
        })
      })
    })
  }
}

const Confirmation = (booking = {}) => ({
  get paymentConfirmation () {
    const {creditCardPayment, paypalPayment, paymentGateway, fakePayment} = booking.confirmation || {}
    return (creditCardPayment || paypalPayment || paymentGateway || fakePayment || {})
  },
  get paidAmount () {
    const {amount, fee = 0} = this.paymentConfirmation
    return amount && (amount - fee)
  },
  get paymentMethod () {
    return (false
      || this.paymentConfirmation.paymentMethod
      || (booking.paidViaUplift ? 'uplift' : this.confirmationType)
    ).toLowerCase()
  },
  get confirmationType () {
    const confirmationType = getConfirmationType(booking.confirmation) || 'unknown'
    return confirmationType.replace('Confirmation', '')
  },
})

function createStateChangeEvent ({user, screen, externalRef}, eventData = {}) {
  const event = Object.assign(
    {
      event: 'stage_changed',
      user: user,
      screen: screen,
    },
    eventData
  )
  if (externalRef) {
    event.campaigns = [{id: externalRef}]
  }
  return event
}

function createEvent (oldState, newState) {
  if (isTabChange(oldState, newState)) {
    return createStateChangeEvent(newState)
  }

  if (isInitialPageLoad(oldState, newState)) {
    const event = createStateChangeEvent(newState, {
      platform: newState.platform,
      gte: newState.gte,
    })
    removeSensitiveDataFromEvent(event)
    return event
  }
}

function createCartJson (newState) {
  const mapLineWithCardIdRemoved = line => {
    delete line.cart_id
    return line
  }

  return {
    id: newState.cart.cartId,
    currency: newState.priceBreakdown.currency.toLowerCase(),
    lines: [party.cartLinesFor(newState)].concat(
      flights.cartLinesFor(newState).map(mapLineWithCardIdRemoved),
      transfers.cartLinesFor(newState),
      travelProtection.cartLinesFor(newState),
      prePaidGratuities.cartLinesFor(newState).map(mapLineWithCardIdRemoved),
      extraDays.cartLinesFor(newState)
    ),
  }
}

function removeSensitiveDataFromEvent (event) {
  /**
   * @TODO: !WARNING! this function removes sensitive data
   *   from a user which is same as in newState
   */
  delete event.user.email
  delete event.user.status
  delete event.user.location
}

function createTransaction (newState, cartJson) {
  const {booking} = newState
  const {totalAmount} = booking.booking
  const {paidAmount, paymentMethod} = Confirmation(booking)

  const transaction = {
    cart: cartJson,
    id: booking.booking.bookingId,
    paymentMethod,
    value: moneyString(totalAmount),
    paidAmount: moneyString(paidAmount || 0),
  }
  transaction.type = false
    || (booking.confirmation.onHold && 'Hold')
    || (booking.confirmation.tourOnRequest && 'On request')
    || (paidAmount >= totalAmount ? 'Full' : 'Part')

  if (booking.booking.externalRef) {
    transaction.affiliation = booking.booking.externalRef
  }

  return transaction
}

function decorateEvent (event, newState) {
  const cartJson = createCartJson(newState)
  updateCartWithPromotions(cartJson, newState.priceBreakdown)

  if (['extras', 'passengers'].includes(newState.tab)) {
    removeSensitiveDataFromEvent(event)
  }

  if ('confirmation' === newState.tab) {
    event.transaction = createTransaction(newState, cartJson)
  } else {
    event.cart = cartJson
  }

  return event
}

export const getPaidAmount = booking => Confirmation(booking).paidAmount
export const eventsFor = (oldState, newState) => {
  const event = createEvent(oldState, newState)
  return event ? [decorateEvent(event, newState)] : []
}

